<template>
    <div v-if="mostrar" class="modal-mask" @click="$emit('fechar')">
        <div class="jm" style="height: min-content; width: 45rem; padding: 2rem;" @click.stop>
            <div style="display: flex; justify-content: center">
                <h2>{{ planoNome }}</h2>
            </div>
            <br>
            <div style="width: 100%; display: flex; justify-content: center;">
                <div style="width: 50%;">
                    <label>Data de término</label>
                    <input :class="{ shake: showShake }" v-model="dataTermino" id="dataTermino"
                        class="form-control" type="date">
                </div>
                <div style="align-content: end; margin-left: 1rem;">
                    <button @click="onFinalizar">Finalizar PAP</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "ModalFinalizarPlanoPAP",
    props: {
        mostrar: { type: Boolean, default: false },
        planoNome: { type: String, default: "" },
    },
    emits: ["fechar", "finalizar"],
    data() {
        return {
            dataTermino: null,
            showShake: false,
        };
    },
    watch: {
        mostrar(visivel) {
            if (visivel) this.dataTermino = null;
        },
    },
    methods: {
        onFinalizar() {
            if (!this.dataTermino) {
                const el = document.getElementById("dataTermino");
                if (el) el.style.border = "1px solid red";
                this.showShake = true;
                setTimeout(() => { this.showShake = false; }, 1500);
                return;
            }
            this.$emit("finalizar", this.dataTermino);
        },
    },
};
</script>
